import React, { useCallback, useEffect, useState } from "react";
import { Pencil, Scroll } from "phosphor-react";
import TableWrapper from "components/common/table-wrapper";
import { DEBOUNCE_DELAY, initialMetaForTable } from "constants/common";
import { createMember, getMembers, updateMember } from "containers/members/api";
import CustomModal from "components/common/modal";
import Addmemberform from "../../components/members/Addmemberform";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
} from "react-router-dom";
import { highlightFirstMatch, formatDateDiff } from "utils/common";

import Tooltip from "components/common/tooltip";

let timeout;

const SortableTableHeader = ({
  columnKey,
  label,
  sortConfig,
  onSortChange,
}) => {
  const isSorting = sortConfig.key === columnKey;
  const isAscending = isSorting && sortConfig.direction === "asc";

  const handleSort = () => {
    if (isAscending) {
      onSortChange(columnKey, "desc");
    } else {
      onSortChange(columnKey, "asc");
    }
  };

  return (
    <th onClick={handleSort} style={{ cursor: "pointer" }}>
      <div className="d-flex position-relative">
        <div className="d-flex flex-column cursor-pointer me-2 position-absolute top-50  end-100 translate-middle-y ">
          {/* <CaretUp size={12} color={isAscending ? '#000000' : '#00000050'} weight="fill" />
          <CaretDown color={isDescending ? '#000000' : '#00000050'} size={12} weight="fill" /> */}
        </div>
        <div>{label}</div>
      </div>
    </th>
  );
};

const columns = [
  { columnKey: "name", label: "Member Name", isSortable: true },
  { columnKey: "date_of_birth", label: "DOB", isSortable: true },
  { columnKey: "phone_number", label: "Phone Number", isSortable: true },
  { columnKey: "health_plan_name", label: "HP", isSortable: true },
  { columnkey: "mif_status", label: "MIF status", issortable: false },
  { columnKey: "ecm", label: "ECM Status", isSortable: true },
  {
    columnKey: "last_survey_completed",
    label: "Last Survey Complete",
    isSortable: true,
  },
  // { columnKey: "in_person", label: "IP", isSortable: true },
  // { columnKey: "telephonic", label: "Tel", isSortable: true },
  { columnKey: "", label: "", isSortable: false },
  { columnKey: "", label: "", isSortable: false },
];
const History = () => {
  const [membersList, setmembersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
    mif_status: "active",
  });
  console.log("===  meta:", meta);
  const [loading, setLoading] = useState(true);
  const [selectedmembers, setSelectedmembers] = useState(0);
  const [selectedMember, setSelectedMember] = useState("");
  const [ismemberModalVisible, setmemberIsModalVisible] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }));
    debounceFn(handleRefreshPage, DEBOUNCE_DELAY);
  };
  const handleSetMifFilter = () => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      mif_status: prevMeta.mif_status === "active" ? "inactive" : "active",
    }));
    handleRefreshPage();
  };
  const handlePageChange = (value) => {
    navigate({ search: createSearchParams({ page: value }).toString() });
    handleRefreshPage();
  };
  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };

  const fetchMembers = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getMembers({
        ...meta,
        page: searchParams.get("page") ? searchParams.get("page") : 1,
        key: sortConfig.key,
        order: sortConfig.direction,
        history: true,
      });
      console.log("memebers", result);
      if (result["members"]) {
        const data = result?.members.map((item) => ({
          ...item,
          checked: selectAll,
        }));
        setmembersList(data);
        setTotalCount(result?.meta.total_count);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    refreshPage,
    sortConfig.direction,
    sortConfig.key,
    searchParams.get("page"),
  ]);

  useEffect(() => {
    fetchMembers();
  }, [fetchMembers]);

  useEffect(() => {
    setSelectedmembers(
      selectAll
        ? membersList.length
        : membersList.reduce((accumulator, item) => {
            if (item.checked) {
              return accumulator + 1;
            } else return accumulator;
          }, 0)
    );
  }, [membersList, selectAll]);
  const handleOpenmemberModal = () => {
    setmemberIsModalVisible(true);
  };
  const handleClosememberModal = () => {
    setmemberIsModalVisible(false);
    setSelectedMember("");
  };
  const handlememberSubmission = async (member, setErrors) => {
    try {
      let result = "";
      if (selectedMember) {
        result = await updateMember(member, selectedMember.id, setErrors);
      } else result = await createMember(member, setErrors);
      if (result) {
        handleClosememberModal();
        handleRefreshPage();
      }
    } catch (error) {
      console.log("error is ", error);
    }
  };

  return (
    <>
      <TableWrapper
        searchPlaceholder="Search Members"
        setSearhQuery={handleSetSearchQuery}
        searchValue={meta.search}
        totalListCount={totalCount}
        pageSize={meta.perPage}
        currentPage={
          searchParams.get("page") ? parseInt(searchParams.get("page")) : 1
        }
        onPageChange={handlePageChange}
        selectedItems={selectedmembers}
        isLoading={loading}
        meta={meta}
        setMeta={setMeta}
        handleRefreshPage={handleRefreshPage}
        actionButtons={
          selectedmembers > 0
            ? [
                // {
                //   label: `Delete ${selectedmembers} Items`,
                //   classes: 'danger-btn m-0-imp',
                //   icon: <TrashSimple size={24} className="me-3" />,
                //   handleClick: handleBulkDeleteMembers,
                // },
              ]
            : [
                {
                  label:
                    meta.mif_status === "inactive"
                      ? "Inactive MIF"
                      : meta.mif_status === "active"
                      ? "Active MIF"
                      : "MIF Status",
                  selectedFilter: meta.mif_status,
                  handlefilterSelect: (selectedValue) =>
                    handleSetMifFilter(selectedValue),
                  dropdown: true,
                  dropdownOptions: [
                    {
                      label: "Active",
                      value: "active",
                    },
                    {
                      label: "Inactive",
                      value: "inactive",
                    },
                  ],
                },
              ]
        }
      >
        <div className="container-fluid ">
          <div className=" overflow-scroll boarder-radius-20px scrollable">
            <table className="table table-rows ">
              <thead className="table-header">
                <tr>
                  {columns.map((column) => (
                    <SortableTableHeader
                      key={column.columnKey}
                      columnKey={column.columnKey}
                      label={column.label}
                      isSortable={column.isSortable}
                      sortConfig={sortConfig}
                      onSortChange={handleSort}
                    />
                  ))}
                </tr>
              </thead>
              <tbody className="table-body">
                {membersList?.map((member, index) => (
                  <tr key={index}>
                    <td className="fw-bold  ">
                      {highlightFirstMatch(member.name, meta.search)}
                    </td>
                    <td className=" ">{member.date_of_birth}</td>
                    <td className=" ">
                      {highlightFirstMatch(member.phone_number, meta.search)}
                    </td>
                    <td className=" ">
                      {highlightFirstMatch(
                        member?.health_plan?.name,
                        meta.search
                      )}
                    </td>
                    <td>
                      <div
                        className={`status ${
                          member.mif_status === "active" ? "active" : "inactive"
                        }`}
                      >
                        {member.mif_status.charAt(0).toUpperCase() +
                          member.mif_status.slice(1)}
                      </div>
                    </td>
                    <td>
                      <div
                        className={`status ms-3 ${
                          member.enrollment_status === "NEW"
                            ? "Excluded"
                            : member.enrollment_status === "OU"
                            ? "pending"
                            : "pending"
                        }`}
                      >
                        {member.enrollment_status.charAt(0).toUpperCase() +
                          member.enrollment_status.slice(1)}
                      </div>
                    </td>
                    <td>{formatDateDiff(member.last_survey_completed)}</td>
                    {/* <td className=" ">{member.in_person}</td>
                    <td className=" ">{member.telephonic}</td> */}
                    <td>
                      <Tooltip title="History">
                        <Scroll
                          size={24}
                          className="cursor-pointer"
                          onClick={() => {
                            navigate(`/members/${member.id}`);
                            localStorage.setItem(
                              "member",
                              JSON.stringify(member)
                            );
                          }}
                        />
                      </Tooltip>
                      <Tooltip title="Edit">
                        <Pencil
                          size={24}
                          className=" ms-3  cursor-pointer"
                          onClick={() => {
                            setSelectedMember(member);
                            handleOpenmemberModal();
                          }}
                        />
                      </Tooltip>
                    </td>
                    {/* <td>
                      <button
                        className={`secondary-btns cursor-pointer  ${(member.pending_survey &&
                          "pending") ||
                          (member.in_progress_survey && " pending") ||
                          "Excluded"}  cursor-pointer `}
                        onClick={() => {
                          navigate(`/survey/${member.id}`, { state: member });
                          localStorage.setItem(
                            "member",
                            JSON.stringify(member)
                          );
                        }}
                      >
                        {(member.pending_survey && "Pending Survey") ||
                          (member.in_progress_survey && "In Progress Survey") ||
                          "Start Survey"}
                      </button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </TableWrapper>
      {ismemberModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleClosememberModal}
          heading={`${selectedMember ? "Edit" : "Add"} Member`}
        >
          <Addmemberform
            handleQuestionSubmittion={handlememberSubmission}
            handleClose={handleClosememberModal}
            selectedMember={selectedMember}
          />
        </CustomModal>
      )}
    </>
  );
};

export default History;
